module.exports = __webpack_public_path__ + "7887d863f6f7643ed4db6e8a7825ddc3.svg";